// Shared phone viewport for sending and the Flow editor simulator.
export const PHONE_PREVIEW_WIDTH =
  '[--phone-preview-width:22.5rem] [dialog:has(&)]:[--phone-preview-width:22.5rem]';
